<template>
  <div class="segments-div">
    <b-badge
      v-for="segment in userInfo.tags"
      :key="segment.id"
      class="segment"
      variant="dark"
      >{{ segment.name || "No Segment" }}
    </b-badge>
    <b-badge class="btn-add-more" variant="light" @click="showTagsModal = true"
      >add more</b-badge
    >
    <b-modal hide-footer title="Edit Industry Segments" v-model="showTagsModal">
      <b-container>
        <b-row class="mb-2">
          <b-col>
            <multiselect
              ref="multiselect"
              v-validate
              data-vv-rules="required"
              data-vv-name="tag"
              data-vv-value-path="tag"
              class="tagsMultiselect"
              v-model="tags"
              :options="allTags"
              track-by="id"
              label="name"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :multiple="true"
              :maxHeight="150"
              :clear-on-select="false"
              open-direction="bottom"
              placeholder="select one or more industry tags"
              :allow-empty="true"
              @open="fetchTags"
            >
            </multiselect>
            <span class="error" v-if="errors.has('tag')">{{
              errors.first("tag")
            }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-badge
              v-for="segment in userInfo.tags"
              :key="segment.id"
              class="segment"
              variant="dark"
              >{{ segment.name || "No Segment" }}
            </b-badge>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <label for="new-tags"> other segment(s)</label>
            <b-input
              v-model="newTags"
              id="new-tags"
              placeholder="add one or more segments separated by comma"
            ></b-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-end mb-2">
          <b-col cols="2"
            >
            <base-button @click="showTagsModal = false"
              >Cancel</base-button
            >
            </b-col
          >
          <b-col cols="2"
            ><base-button @click="saveChanges" type="button"
              >Save</base-button
            ></b-col
          ></b-row
        >
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  name: 'IndustryTags',
  components: {
    Multiselect,
  },
  data() {
    return {
      tags: [],
      newTags: '',
      showTagsModal: false,
    };
  },
  watch: {
    userInfo: {
      deep: true,
      immediate: true,
      handler(data) {
        if (data) {
          this.tags = data.tags;
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
      allTags: 'tags/fetchItems',
    }),
  },
  methods: {
    ...mapActions({
      fetchTags: 'tags/fetchList',
      createTags: 'tags/createTags',
      editUserInfo: 'user/editUserInfo',
    }),
    async saveChanges() {
      try {
        const data = { tags_to_add: [] };
        let createdTags = [];

        if (this.newTags) {
          const tags = this.newTags.split(', ');
          const tagsData = tags.map(tag => ({ name: tag }));
          createdTags = await this.createTags(tagsData);
        }

        if (createdTags.length) {
          createdTags.forEach((tag) => {
            data.tags_to_add.push(tag.url);
          });
        }
        if (this.tags.length) {
          this.tags.forEach((tag) => {
            data.tags_to_add.push(tag.url);
          });
        }

        await this.editUserInfo(data);
        this.$notify({
          group: 'userAlerts',
          title: 'Success',
          text: 'Your changes have been saved!',
          type: 'success',
        });
        this.showTagsModal = false;
        this.newTags = '';
      } catch (err) {
        this.$notify({
          group: 'userAlerts',
          title: 'Error',
          text: 'Tag with this name already exists, please check once again!',
          type: 'error',
        });
      }
    },
  },
};
</script>

<style scoped>
.segments-div {
  padding: 20px;
  text-align: left;
}
.segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #aaaaaa;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: white;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.btn-add-more:hover,
.segment:hover {
  cursor: pointer;
  background-color: #bd9d5f;
  color: white;
}
.btn-add-more {
  font-size: 12px;
  padding: 4px 8px;
  user-select: none;
  margin: 7px 7px 7px 0px;
  color: #bd9d5f;
  background: #ebebeb;
  box-shadow: none;
  border-radius: 0 10px 10px 10px;
  font-weight: normal;
}
</style>
<style>
.tagsMultiselect .multiselect__tag {
  padding: 3px 5px;
  border-radius: 8px;
  margin-right: 4px;
  background-color: #aaaaaa;
  font-size: 10px;
}
.tagsMultiselect .multiselect__tag-icon {
  display: none;
}
</style>
